<template>
    <BlogArchivePage />
</template>
